// Angular
import {Component, EventEmitter, OnInit, Output} from '@angular/core';
// Local services
import { ProfileService } from '../../seguridad-creacion-perfil/profile.service';
import { AlertService } from '../../../services/alert.service';
// 3rd libraries
import { NgxUiLoaderService } from 'ngx-ui-loader';
// Messages
import { GlobalMessages } from '../../../utils/messages';
import {Messages} from '../../seguridad-listado-roles/messages';

@Component({
  selector: 'app-security-user-list',
  templateUrl: './security-user-list.component.html',
  styleUrls: ['./security-user-list.component.scss']
})
export class SecurityUserListComponent implements OnInit {
  @Output() selecttab = new EventEmitter<any>();
  // Data
  data = [];
  // Pagination
  p = 1;
  itemsPerPage = 10;
  searchString = '';

  constructor(
    private alertService: AlertService,
    private loaderService: NgxUiLoaderService,
    private profileService: ProfileService,
  ) { }

  async ngOnInit() {
    await this.getProfiles();
  }

  changeMenuModule(tab): void {
    this.selecttab.emit(tab);
  }


  async getProfiles() {
    this.loaderService.startLoader('loader-global', 'loadingDashboard');
    const result = await this.profileService.getProfiles();
    if (result && result.codigo === 1) {
     this.data = result.Respuesta;
     this.loaderService.stopLoader('loader-global', 'loadingDashboard');
    } else {
      this.loaderService.stopLoader('loader-global', 'loadingDashboard');
      await this.alertService.show(
        GlobalMessages.GENERAL_ERROR_TITLE,
        GlobalMessages.GENERAL_ERROR_BODY,
      );
    }
  }

  async changeUserStatus(user: any) {
    this.loaderService.startLoader('loader-global', 'loadingDashboard');
    const result = await this.profileService.updateProfile({
      idPerfil: 0,
      idRol: +user.id_rol,
      nombreCompleto: user.nombre_completo,
      codigoAntiguedad: user.codigo_antiguedad,
      puesto: user.puesto ?? '',
      correo: user.correo,
      unidadAdministrativa: user.unidad_administrativa ?? '',
      direccion: user.direccion ?? '',
      usuario: user.usuario,
      activo: user.activo,
    });
    if (result && result.codigo === 1) {
      await this.getProfiles();
      await this.alertService.show(
        GlobalMessages.NOTE_TITLE,
        Messages.CHANGE_STATUS_USER_SUCCESS,
      );
      this.loaderService.stopLoader('loader-global', 'loadingDashboard');
    } else {
      this.alertService.show(
        GlobalMessages.GENERAL_ERROR_TITLE,
        GlobalMessages.GENERAL_ERROR_BODY,
      ).then();
      this.loaderService.stopLoader('loader-global', 'loadingDashboard');
    }
  }

  editProfile(profile: any) {
    profile.edit = true;
    this.profileService.setProfile(profile);
  }
}
